import TargetingSourceEditPageReducer from './TargetingSourceEditPageReducer';

export default from './TargetingSourceEditPageContainer';
export const TargetingSourceEditPageReducers = {
  TargetingSourceEditPageReducer,
};
